import { useCallback, useEffect } from 'react';
import { useLocation, useNavigate, useOutletContext, useParams } from 'react-router-dom';
import { SalesView } from '@/components/sales/SalesView';
import type { AppShellContext } from '@/components/layout/AppShell';

export function SalesPage() {
  const { nip } = useParams<{ nip: string }>();
  const { companyName } = useOutletContext<AppShellContext>();
  const navigate = useNavigate();
  const location = useLocation();

  // Carry the current query string (URL-persisted filters) into the detail
  // page so its "back" navigation restores this list exactly — the same
  // mechanism InvoiceListPage uses for the cost list.
  const handleInvoiceSelect = useCallback(
    (invoiceId: string) => {
      navigate(`/${nip}/invoices/${invoiceId}`, {
        state: { listSearch: location.search },
      });
    },
    [nip, navigate, location.search],
  );

  // Clear the refetch flag InvoiceDetailPage sets after a save, so a page
  // refresh doesn't re-trigger anything — filters in the query string stay.
  useEffect(() => {
    if (location.state?.refetch) {
      navigate(location.pathname + location.search, { replace: true, state: {} });
    }
  }, [location.state, location.pathname, location.search, navigate]);

  return (
    <SalesView
      companyNip={nip || ''}
      companyName={companyName}
      onInvoiceSelect={handleInvoiceSelect}
    />
  );
}
